import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import type { AppConfig, AppOAuthConfig } from '../../../environments/environment.model';

@Injectable({ providedIn: 'root' })
export class AppConfigService {
  private readonly config = environment;

  get production(): boolean {
    return this.config.production;
  }

  get apiBaseUrl(): string {
    return this.config.apiBaseUrl;
  }

  get apiCatalogUrl(): string {
    return this.config.apiCatalogUrl;
  }

  get oauth(): AppOAuthConfig {
    return this.config.oauth;
  }

  get snapshot(): AppConfig {
    return this.config;
  }
}
